import { combineReducers } from 'redux';

import user from './user';
import navigation from './navigation';
import reports from './reports';
import forms from './forms';

const reducers = combineReducers({
  user,
  navigation,
  reports,
  forms,
});

export default reducers;
